module.exports = __webpack_public_path__ + "static/img/01.62951ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/02/01.jpg
// module id = X3S3
// module chunks = 0